import { z } from 'zod';

/** PII-free metadata for mutations refused because a nested client row is archived. */
export const ClientChildArchivedMetaSchema = z
  .object({
    kind: z.enum(['legal-entity-archived', 'requisites-archived']),
    clientId: z.string().uuid(),
    childId: z.string().uuid(),
  })
  .strict();
export type ClientChildArchivedMeta = z.infer<typeof ClientChildArchivedMetaSchema>;

/** PII-free metadata for a restore whose historical bank association cannot be proved. */
export const ClientVersionRestoreAmbiguousMetaSchema = z
  .object({
    kind: z.literal('restore-ambiguous'),
    clientId: z.string().uuid(),
    versionId: z.string().uuid(),
    legalEntityIds: z.array(z.string().uuid()).min(1),
  })
  .strict();
export type ClientVersionRestoreAmbiguousMeta = z.infer<
  typeof ClientVersionRestoreAmbiguousMetaSchema
>;
